export enum EvaluationMark {
  NeedsDevelopment = 'needs development',
  Successful = 'successful',
  Exceeds = 'exceeds',
  CantEval = 'can not evaluate',
}
